import {
  createContext, useContext,
} from 'react'

/**
 * What the onboarding demo does in place of a step that leaves the app.
 *
 * Only billing needs it: every other hand-off (the Google consent round trip,
 * channel pairing) is a request the demo's adapter can answer, but Stripe's
 * checkout runs in Stripe's own iframe and needs a real session.
 */
export interface OnboardingDemoControls {
  /** Record the trial a card would have started, as checkout's return would. */
  startTrial: () => void
}

export const OnboardingDemoContext = createContext<OnboardingDemoControls | null>(null)

/** The demo's controls, or `null` everywhere outside the demo. */
export function useOnboardingDemo(): OnboardingDemoControls | null {
  return useContext(OnboardingDemoContext)
}
